import React from "react";
import { Outlet, BrowserRouter, Routes, Route } from "react-router-dom";

import rt from "./locales/routes.json"

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

import Home from './pages/Home';
import Pioneers from "./pages/Pioneers";
import Payments from "./pages/Payments";
import Fees from "./pages/Fees";
import MobileFees from "./pages/MobileFees"
import Coopcentral from "./pages/Coopcentral";
import MobileCoopcentral from "./pages/MobileCoopcentral";
import MobileForm from "./pages/MobileForm";
import MobileSubmitted from "./pages/MobileSubmitted";

import './App.css';
import './global.sass';

export default function App() {

  const WebsiteLayout = () => (
    <>
      <ScrollToTop />
      <Header />
      <Outlet />
      <Footer />
    </>
  );

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path={rt.mobilefees} element={<MobileFees/>} />
        <Route exact path={rt.mobilebank} element={<MobileCoopcentral/>} />
        <Route exact path={rt.mobileform} element={<MobileForm/>} />
        <Route exact path={rt.mobilesubmitted} element={<MobileSubmitted/>} />
        <Route element={<WebsiteLayout />} >
          <Route exact path={rt.home} element={<Home/>} />
          <Route exact path={rt.pioneers} element={<Pioneers/>} />
          <Route exact path={rt.payments} element={<Payments/>} />
          <Route exact path={rt.fees} element={<Fees/>} />
          <Route exact path={rt.bank} element={<Coopcentral/>} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

